import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';

const CO_APPROVE_RESOURCE = 'coApproveImpersonation';
const ORG_IMPERSONATION_RESOURCE = 'orgImpersonationRequests';

const coApproveImpersonationService = ComposedComponent =>
  reduxFetch([
    {
      resource: CO_APPROVE_RESOURCE,
      method: 'put',
      request: (id, body, callback, t) => ({
        url: apiRoutes.coApproveImpersonation(id),
        body,
        meta: {
          removeFromOtherList: {
            resource: ORG_IMPERSONATION_RESOURCE,
            idProp: 'id',
            id,
          },
          callback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'coApproveImpersonationFailed'),
            onSuccessMessage: t('coApproveImpersonationSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default coApproveImpersonationService;
